import { styled } from '@mui/material/styles';
import {
  TextField, Typography, IconButton,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import colors from '../../../styles/colors';

const Container = styled('div')({
  padding: '30px',
  display: 'flex',
  gap: '16px',
  alignItems: 'flex-start',
  flexDirection: 'row',
  '@media (max-width: 960px)': {
    flexDirection: 'column',
  },
});

const FormPanel = styled('div')({
  border: `1px solid ${colors.shades.gamma3}`,
  borderRadius: '4px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flex: '1',
  overflowY: 'auto',
});

const ButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  gap: '16px',
});

const ThemesPanel = styled('div')({
  border: `1px solid ${colors.shades.gamma3}`,
  // borderBottom: 'none',
  display: 'flex',
  flexDirection: 'column',
  flex: '2',
  maxHeight: 'calc(100vh - 125px)',
  overflowY: 'auto',
  borderRadius: '4px',
});

const DatePickerContainer = styled('div')({
  display: 'flex',
  gap: '16px',
  alignItems: 'flex-start',
});

const StyledTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    height: '55px',
  },
  '& .MuiInputLabel-root': {
    fontSize: '16px',
  },
});

const StyledTextarea = styled('textarea')({
  width: '100%',
  resize: 'vertical',
  fontFamily: 'inherit',
  fontSize: '14px',
  padding: '8px',
  border: `1px solid ${colors.shades.gamma3}`,
  borderRadius: '4px',
  outline: 'none',
  height: '100px',
  '&:blur': {
    borderColor: colors.base.support,
  },
  '&: hover': {
    borderColor: colors.base.beta,
  },
  '&: focus': {
    borderColor: colors.base.primary,
    borderWidth: '2px',
  },
});

const StyledButton = styled(LoadingButton)({
  minWidth: '100px',
});

const ThemeCard = styled('div')(({ isActive }) => ({
  borderBottom: `1px solid ${colors.shades.gamma3}`,
  padding: '10px',
  position: 'relative',
  backgroundColor: isActive ? colors.shades.primary3 : '',
}));

const ThemeCardActionsRow = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '8px',
});

const ThemeTitle = styled(Typography)({
  fontWeight: 'bold',
  marginBottom: '4px',
});

const ThemeDate = styled(Typography)({
  fontSize: '14px',
  color: colors.shades.gamma10,
});

const ThemeDescription = styled(Typography)({
  fontSize: '14px',
  lineHeight: '1.4',
  marginBottom: '4px',
});

const ActiveBadge = styled(Typography)({
  color: 'green',
  fontSize: '12px',
  fontWeight: '500',
});

const ActionButtons = styled('div')({
  position: 'absolute',
  top: 8,
  right: 8,
  display: 'flex',
  gap: '4px',
});

const EditButton = styled(IconButton)({
  color: colors.base.secondary2,
});

const DeleteButton = styled(IconButton)({
  color: colors.base.secondary2,
});

const EmptyState = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  color: colors.base.beta,
  fontStyle: 'italic',
  padding: '20px',
});

const ActiveChip = styled('div')({
  backgroundColor: colors.base.primary,
  color: colors.base.beta,
  padding: '4px 8px',
  borderRadius: '4px',
  fontSize: '12px',
  fontWeight: '500',
  zIndex: 1,
});

export {
  Container,
  FormPanel,
  ButtonContainer,
  ThemesPanel,
  DatePickerContainer,
  StyledTextField,
  StyledTextarea,
  StyledButton,
  ThemeCard,
  ThemeCardActionsRow,
  ThemeTitle,
  ThemeDate,
  ThemeDescription,
  ActiveBadge,
  ActionButtons,
  EditButton,
  DeleteButton,
  EmptyState,
  ActiveChip,
};
